// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── StcPage — ShemsPaie ── */

.stc-page h2.stc-title {
  color: var(--color-dark-brown);
}
.stc-subtitle {
  font-size: 0.8rem;
  color: #999;
  margin-top: 3px;
}

/* ── Motif filter cards ── */
.stc-motif-cards {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.stc-motif-card {
  flex: 1 1 130px;
  min-width: 120px;
  background: #fff;
  border: 2px solid color-mix(in srgb, var(--mc) 30%, #ddd);
  border-top: 3px solid var(--mc);
  border-radius: 12px;
  padding: 10px 14px;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s ease;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.stc-motif-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--mc) 20%, transparent);
  border-color: var(--mc);
}
.stc-motif-card--active {
  background: var(--mc);
  border-color: var(--mc);
  box-shadow: 0 4px 16px color-mix(in srgb, var(--mc) 35%, transparent);
  transform: translateY(-1px);
}
.stc-motif-card--active .stc-mc-label,
.stc-motif-card--active .stc-mc-count,
.stc-motif-card--active .stc-mc-total {
  color: #fff !important;
}

.stc-mc-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--mc);
  margin-bottom: 4px;
}
.stc-mc-count {
  font-size: 1.3rem;
  font-weight: 900;
  color: #2a1a0a;
  line-height: 1;
}
.stc-mc-count span {
  font-size: 0.68rem;
  font-weight: 500;
  color: #aaa;
  margin-left: 3px;
}
.stc-mc-total {
  font-size: 0.72rem;
  font-weight: 600;
  color: #888;
  margin-top: 3px;
}
.stc-mc-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding: 8px 14px;
  background: rgba(109,78,54,0.07);
  border-radius: 12px;
  min-width: 70px;
  text-align: center;
}
.stc-mc-result span {
  font-size: 1.4rem;
  font-weight: 900;
  color: #6d4e36;
  line-height: 1;
}
.stc-mc-result small {
  font-size: 0.65rem;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ── Filter card ── */
.stc-filter-card:hover {
  transform: none !important;
  transition: none !important;
}
.stc-filter-card {
  border-radius: 14px;
  border: 1.5px solid rgba(109, 78, 54, 0.22);
  background: #fff;
}
.stc-search-icon {
  background: rgba(109, 78, 54, 0.07);
  border: none;
  color: #6d4e36;
}
.stc-search-input {
  border: none;
  box-shadow: none !important;
}
.stc-filter-card .input-group {
  border-radius: 10px;
  overflow: hidden;
  border: 1.5px solid rgba(109, 78, 54, 0.22);
}
.stc-filter-card .input-group:focus-within {
  border-color: #6d4e36;
}

/* ── Table card ── */
.stc-table-card:hover {
  transform: none !important;
  transition: none !important;
}
.stc-table-card {
  border-radius: 14px;
  border: 1.5px solid rgba(109, 78, 54, 0.18);
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
}
.stc-table-scroll {
  overflow-x: auto;
}
.stc-table {
  min-width: 860px;
  margin-bottom: 0;
}
.stc-table thead th {
  background: #faf7f4;
  color: #6d4e36;
  font-size: 0.73rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.055em;
  border-bottom: 2px solid rgba(109, 78, 54, 0.18);
  white-space: nowrap;
  padding: 10px 14px;
}
.stc-table tbody td {
  vertical-align: middle;
  padding: 10px 14px;
  border-color: rgba(109, 78, 54, 0.07);
}
.stc-table tbody tr:hover td {
  background: rgba(109, 78, 54, 0.03) !important;
}

/* ── Table cells ── */
.stc-id { color: #bbb; font-size: 0.8rem; }

.stc-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}
.stc-name {
  font-weight: 600;
  color: #3a2a1a;
}
.stc-locked-icon {
  color: #b71c1c;
  font-size: 0.68rem;
  opacity: 0.7;
}

.stc-code {
  font-family: monospace;
  font-size: 0.82rem;
  color: #555;
  background: none;
  padding: 0;
}

.stc-qual {
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.85rem;
}

.stc-chip {
  display: inline-block;
  background: rgba(109, 78, 54, 0.1);
  color: #6d4e36;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 0.77rem;
  font-weight: 600;
  white-space: nowrap;
}

.stc-anciennete {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.stc-anc-val {
  font-weight: 700;
  color: #6f42c1;
  font-size: 0.88rem;
}
.stc-anc-from {
  font-size: 0.7rem;
  color: #aaa;
}

.stc-date-badge {
  font-size: 0.72rem;
  padding: 4px 8px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

.stc-calc-btn {
  display: inline-flex;
  align-items: center;
  font-size: 0.82rem;
  padding: 4px 12px;
  border-radius: 8px;
}

/* ── Bloqué row ── */
.stc-row-bloque td {
  opacity: 0.5;
  background-color: #f8f8f8 !important;
}
.stc-row-bloque .stc-name {
  text-decoration: line-through;
  color: #999;
}

/* ── Empty state ── */
.stc-empty {
  text-align: center;
  padding: 48px 0;
  color: #ccc;
}
.stc-empty-icon {
  font-size: 2.4rem;
  margin-bottom: 10px;
  opacity: 0.3;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* ── Modal ── */
.stc-modal-header {
  background: #faf7f4;
  border-bottom: 1.5px solid rgba(109, 78, 54, 0.2);
}

.stc-period-alert {
  border-radius: 10px;
  font-size: 0.88rem;
}

.stc-field-label {
  font-size: 0.82rem;
  color: #555;
  margin-bottom: 4px;
  display: block;
}
.stc-auto-hint {
  font-size: 0.72rem;
  color: #6f42c1;
  font-weight: 400;
}

.stc-amount-input {
  font-family: monospace;
  font-size: 0.95rem;
  font-weight: 600;
}

/* ── Total box ── */
.stc-total-box {
  background: linear-gradient(135deg, rgba(111, 66, 193, 0.12), rgba(109, 78, 54, 0.08));
  border: 2px solid rgba(111, 66, 193, 0.3);
  border-radius: 12px;
  padding: 14px 18px;
  text-align: center;
}
.stc-total-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #888;
  font-weight: 700;
  margin-bottom: 4px;
}
.stc-total-value {
  font-size: 1.6rem;
  font-weight: 900;
  color: #6f42c1;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/StcPage.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;EACzD,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,2BAA2B;EAC3B,qEAAqE;EACrE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qEAAqE;EACrE,2BAA2B;AAC7B;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB,UAAU,WAAW,EAAE,iBAAiB,EAAE;;AAE1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,sFAAsF;EACtF,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* ── StcPage — ShemsPaie ── */\r\n\r\n.stc-page h2.stc-title {\r\n  color: var(--color-dark-brown);\r\n}\r\n.stc-subtitle {\r\n  font-size: 0.8rem;\r\n  color: #999;\r\n  margin-top: 3px;\r\n}\r\n\r\n/* ── Motif filter cards ── */\r\n.stc-motif-cards {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.stc-motif-card {\r\n  flex: 1 1 130px;\r\n  min-width: 120px;\r\n  background: #fff;\r\n  border: 2px solid color-mix(in srgb, var(--mc) 30%, #ddd);\r\n  border-top: 3px solid var(--mc);\r\n  border-radius: 12px;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: all 0.15s ease;\r\n  box-shadow: 0 1px 4px rgba(0,0,0,0.05);\r\n}\r\n.stc-motif-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--mc) 20%, transparent);\r\n  border-color: var(--mc);\r\n}\r\n.stc-motif-card--active {\r\n  background: var(--mc);\r\n  border-color: var(--mc);\r\n  box-shadow: 0 4px 16px color-mix(in srgb, var(--mc) 35%, transparent);\r\n  transform: translateY(-1px);\r\n}\r\n.stc-motif-card--active .stc-mc-label,\r\n.stc-motif-card--active .stc-mc-count,\r\n.stc-motif-card--active .stc-mc-total {\r\n  color: #fff !important;\r\n}\r\n\r\n.stc-mc-label {\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: var(--mc);\r\n  margin-bottom: 4px;\r\n}\r\n.stc-mc-count {\r\n  font-size: 1.3rem;\r\n  font-weight: 900;\r\n  color: #2a1a0a;\r\n  line-height: 1;\r\n}\r\n.stc-mc-count span {\r\n  font-size: 0.68rem;\r\n  font-weight: 500;\r\n  color: #aaa;\r\n  margin-left: 3px;\r\n}\r\n.stc-mc-total {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: #888;\r\n  margin-top: 3px;\r\n}\r\n.stc-mc-result {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: auto;\r\n  padding: 8px 14px;\r\n  background: rgba(109,78,54,0.07);\r\n  border-radius: 12px;\r\n  min-width: 70px;\r\n  text-align: center;\r\n}\r\n.stc-mc-result span {\r\n  font-size: 1.4rem;\r\n  font-weight: 900;\r\n  color: #6d4e36;\r\n  line-height: 1;\r\n}\r\n.stc-mc-result small {\r\n  font-size: 0.65rem;\r\n  color: #aaa;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n/* ── Filter card ── */\r\n.stc-filter-card:hover {\r\n  transform: none !important;\r\n  transition: none !important;\r\n}\r\n.stc-filter-card {\r\n  border-radius: 14px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.22);\r\n  background: #fff;\r\n}\r\n.stc-search-icon {\r\n  background: rgba(109, 78, 54, 0.07);\r\n  border: none;\r\n  color: #6d4e36;\r\n}\r\n.stc-search-input {\r\n  border: none;\r\n  box-shadow: none !important;\r\n}\r\n.stc-filter-card .input-group {\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.22);\r\n}\r\n.stc-filter-card .input-group:focus-within {\r\n  border-color: #6d4e36;\r\n}\r\n\r\n/* ── Table card ── */\r\n.stc-table-card:hover {\r\n  transform: none !important;\r\n  transition: none !important;\r\n}\r\n.stc-table-card {\r\n  border-radius: 14px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.18);\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 16px rgba(0,0,0,0.06);\r\n}\r\n.stc-table-scroll {\r\n  overflow-x: auto;\r\n}\r\n.stc-table {\r\n  min-width: 860px;\r\n  margin-bottom: 0;\r\n}\r\n.stc-table thead th {\r\n  background: #faf7f4;\r\n  color: #6d4e36;\r\n  font-size: 0.73rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.055em;\r\n  border-bottom: 2px solid rgba(109, 78, 54, 0.18);\r\n  white-space: nowrap;\r\n  padding: 10px 14px;\r\n}\r\n.stc-table tbody td {\r\n  vertical-align: middle;\r\n  padding: 10px 14px;\r\n  border-color: rgba(109, 78, 54, 0.07);\r\n}\r\n.stc-table tbody tr:hover td {\r\n  background: rgba(109, 78, 54, 0.03) !important;\r\n}\r\n\r\n/* ── Table cells ── */\r\n.stc-id { color: #bbb; font-size: 0.8rem; }\r\n\r\n.stc-name-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.stc-name {\r\n  font-weight: 600;\r\n  color: #3a2a1a;\r\n}\r\n.stc-locked-icon {\r\n  color: #b71c1c;\r\n  font-size: 0.68rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.stc-code {\r\n  font-family: monospace;\r\n  font-size: 0.82rem;\r\n  color: #555;\r\n  background: none;\r\n  padding: 0;\r\n}\r\n\r\n.stc-qual {\r\n  max-width: 150px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.stc-chip {\r\n  display: inline-block;\r\n  background: rgba(109, 78, 54, 0.1);\r\n  color: #6d4e36;\r\n  border-radius: 20px;\r\n  padding: 2px 10px;\r\n  font-size: 0.77rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.stc-anciennete {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n}\r\n.stc-anc-val {\r\n  font-weight: 700;\r\n  color: #6f42c1;\r\n  font-size: 0.88rem;\r\n}\r\n.stc-anc-from {\r\n  font-size: 0.7rem;\r\n  color: #aaa;\r\n}\r\n\r\n.stc-date-badge {\r\n  font-size: 0.72rem;\r\n  padding: 4px 8px;\r\n  border-radius: 20px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.stc-calc-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  font-size: 0.82rem;\r\n  padding: 4px 12px;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* ── Bloqué row ── */\r\n.stc-row-bloque td {\r\n  opacity: 0.5;\r\n  background-color: #f8f8f8 !important;\r\n}\r\n.stc-row-bloque .stc-name {\r\n  text-decoration: line-through;\r\n  color: #999;\r\n}\r\n\r\n/* ── Empty state ── */\r\n.stc-empty {\r\n  text-align: center;\r\n  padding: 48px 0;\r\n  color: #ccc;\r\n}\r\n.stc-empty-icon {\r\n  font-size: 2.4rem;\r\n  margin-bottom: 10px;\r\n  opacity: 0.3;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n/* ── Modal ── */\r\n.stc-modal-header {\r\n  background: #faf7f4;\r\n  border-bottom: 1.5px solid rgba(109, 78, 54, 0.2);\r\n}\r\n\r\n.stc-period-alert {\r\n  border-radius: 10px;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.stc-field-label {\r\n  font-size: 0.82rem;\r\n  color: #555;\r\n  margin-bottom: 4px;\r\n  display: block;\r\n}\r\n.stc-auto-hint {\r\n  font-size: 0.72rem;\r\n  color: #6f42c1;\r\n  font-weight: 400;\r\n}\r\n\r\n.stc-amount-input {\r\n  font-family: monospace;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ── Total box ── */\r\n.stc-total-box {\r\n  background: linear-gradient(135deg, rgba(111, 66, 193, 0.12), rgba(109, 78, 54, 0.08));\r\n  border: 2px solid rgba(111, 66, 193, 0.3);\r\n  border-radius: 12px;\r\n  padding: 14px 18px;\r\n  text-align: center;\r\n}\r\n.stc-total-label {\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.07em;\r\n  color: #888;\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n.stc-total-value {\r\n  font-size: 1.6rem;\r\n  font-weight: 900;\r\n  color: #6f42c1;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
